import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, textColumn } from "./ColumnHelpers";

export function column_Farm(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "importFarmName", "farm");
}
